import React, { useEffect } from 'react';
import Buttons from '../../../../common/Buttons';
import { useDispatch, useSelector } from 'react-redux';
import IconToolTip from '../../../../common/IconToolTip';
import { HandleAccessForButtons } from '../../TeamController';
import { getUserDetails } from '../../../../actions/users';
import { textCss } from '../../../../common/Css';


export default function UserDetails(props) {

  const { onClose, handleRemove, headerComponent } = props;
  const { selectedUserDetails } = useSelector((state) => state.customer)
  const dispatch = useDispatch();
  const isToShowDeletButton = HandleAccessForButtons('USERS_TEAM_DELETE')

  const defaultPic = process.env.PUBLIC_URL + './img/default-profile-pic.svg';
  const profile_pic = selectedUserDetails?.user?.profile_pic;

  useEffect(() => {
    if (selectedUserDetails) {
      dispatch(getUserDetails({ userId: selectedUserDetails.id }))
    }
  }, [])


  const handleRemoveFromTeam = ({ selectedUserDetails, team }) => {
    let data = {
      agentId: selectedUserDetails?.fk_user_id,
      teamId: team?.id,
      agentName: `${selectedUserDetails?.user?.first_name} ${selectedUserDetails?.user?.last_name}`,
      teamName: team?.name,
      customerId: team?.fk_customer_id,
      tabName: 'team_users'
    }
    handleRemove(data)
  }



  return (
    <div className='sticky'>
      {headerComponent({ headName: 'User Details', onClick: onClose })}

      <div className='h-screen pb-48 overflow-y-auto '>
        <div className='border-t border-scogogray pt-5'>
          <div className=''>

            <img
              src={`${profile_pic ? profile_pic : defaultPic}`}
              className=' h-24 rounded-full mx-auto object-cover'
              alt=''
            />
          </div>
          <p className={`text-center mt-m-15 ${textCss?.headerOne}`}>
            {`${selectedUserDetails?.user?.first_name} ${selectedUserDetails?.user?.last_name}`}
          </p>
          <div className='text-center mt-2 mb-4'>
            <p className={textCss?.headerThree}>{selectedUserDetails?.user?.mobile}</p>
            <p className={textCss?.detailsValue}>{selectedUserDetails?.user?.email}</p>
          </div>
        </div>

        <div className='p-5 border-t-10'>
          <div className='mb-m-15 flex items-center'>
            <div>
              <p className='text-font13 text-scogoprimary font-medium mr-3'>
                Teams
              </p>
            </div>
            <div className=''>
              <p className='bg-scogoorange text-white rounded-full h-7 leading-7 text-center text-font11 font-medium'>
                {selectedUserDetails?.team_details?.length}
              </p>
            </div>
          </div>
          {Array.isArray(selectedUserDetails?.team_details) && selectedUserDetails?.team_details?.map(team => (
            <div className='flex items-center'>
              <div>
                <div className='flex items-center py-2'>
                  <div className=''>
                    <p className={textCss?.inputText}>
                      {team.name}
                    </p>
                  </div>
                </div>
              </div>
              <div className='ml-auto'>
                <Buttons>
                  <IconToolTip title='Remove'>
                    {isToShowDeletButton ? <span onClick={() => handleRemoveFromTeam({ selectedUserDetails, team })} className='material-icons text-scogogray 2xl:text-font20 text-font16 text-scogoclosed'>
                      delete
                    </span> : <></>}
                  </IconToolTip>
                </Buttons>
              </div>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
}
